<div class="card shadow-sm border-0">
  <div class="card-body">
    <h5 class="mb-3">Step 4 · Review</h5>

    <div *ngIf="application as app; else noData">
      <div class="row g-3 mb-3">
        <div class="col-md-3">
          <div class="small text-muted">Country</div>
          <div class="fw-semibold">{{ app.jurisdictionCode }}</div>
        </div>

        <div class="col-md-3">
          <div class="small text-muted">Tier</div>
          <div class="fw-semibold">{{ app.tierCode }}</div>
        </div>

        <div class="col-md-3">
          <div class="small text-muted">Product</div>
          <div class="fw-semibold">{{ app.productType }}</div>
        </div>

        <div class="col-md-3">
          <div class="small text-muted">Status</div>
          <div class="fw-semibold">{{ app.status }}</div>
        </div>
      </div>

      <div class="row g-3">
        <div class="col-lg-6">
          <div class="border rounded p-3 h-100">
            <div class="fw-semibold mb-2">Field Values</div>

            <div class="small mb-2"
                 *ngFor="let field of app.fields; trackBy: trackByField">
              <div class="text-muted">{{ field.label || field.fieldKey }}</div>
              <div class="fw-semibold">{{ field.fieldValue || '-' }}</div>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="border rounded p-3 h-100">
            <div class="fw-semibold mb-2">Uploaded Documents</div>

            <div class="small mb-2"
                 *ngFor="let doc of app.documents; trackBy: trackByDoc">
              <div class="text-muted">{{ doc.label || doc.documentTypeCode }}</div>
              <div class="fw-semibold">{{ doc.fileName }}</div>
              <div class="text-muted">{{ doc.status }}</div>
            </div>

            <div *ngIf="!app.documents?.length" class="text-muted small">
              No documents uploaded yet.
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="app.reviewNotes" class="alert alert-warning mt-3 mb-0">
        <strong>Review notes:</strong> {{ app.reviewNotes }}
      </div>
    </div>

    <ng-template #noData>
      <div class="text-muted">No application data available for review.</div>
    </ng-template>
  </div>
</div>